import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'
import type {
  DeleteEmployeeCertificateMutation,
  DeleteEmployeeCertificateMutationVariables
} from './__generated__/DeleteEmployeeCertificateMutation'

const mutation: TypedDocumentNode<
  DeleteEmployeeCertificateMutation,
  DeleteEmployeeCertificateMutationVariables
> = gql`
  mutation DeleteEmployeeCertificateMutation(
    $input: DeleteEmployeeCertificateInput!
  ) {
    deleteEmployeeCertificate(input: $input) {
      status
    }
  }
`

export function deleteEmployeeCertificateMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      DeleteEmployeeCertificateMutation,
      DeleteEmployeeCertificateMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
